module.exports = __webpack_public_path__ + "static/img/fish22.38a7c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish22.png
// module id = 4lu5
// module chunks = 0